export default __webpack_public_path__ + "static/media/step7-icon.78362fee.svg";